//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './NoteClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetNoteNoteQueryParameters = {
  id: number ;
}

export type UpdateNoteNoteQueryParameters = {
  id: number ;
}

export type RemoveNoteNoteQueryParameters = {
  id: number ;
}

export type GetNoteQueryParameters = {
  from?: Date | null | undefined ;
  to?: Date | null | undefined ;
  endsTill?: Date | null | undefined ;
  importId?: string | null | undefined ;
  excludeWithoutDates?: boolean | null | undefined ;
  importIds?: string[] | null | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export function getNoteUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/note/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getNoteDefaultOptions: Omit<UseQueryOptions<Types.NoteDto, unknown, Types.NoteDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.NoteDto, unknown, Types.NoteDto>, 'queryFn'>> = {
};
export function getGetNoteDefaultOptions() {
  return getNoteDefaultOptions;
};
export function setGetNoteDefaultOptions(options: typeof getNoteDefaultOptions) {
  getNoteDefaultOptions = options;
}

export function getNoteQueryKey(id: number): QueryKey;
export function getNoteQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetNoteNoteQueryParameters;

    return trimArrayEnd([
        'NoteClient',
        'getNote',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'NoteClient',
        'getNote',
        ...params
      ]);
  }
}
export function __getNote(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getNote(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetNoteQuery<TSelectData = Types.NoteDto, TError = unknown>(dto: GetNoteNoteQueryParameters, options?: Omit<UseQueryOptions<Types.NoteDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetNoteQuery<TSelectData = Types.NoteDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.NoteDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetNoteQuery<TSelectData = Types.NoteDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.NoteDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetNoteNoteQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.NoteDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getNote(context, axiosConfig) : __getNote,
    queryKey: getNoteQueryKey(id),
    ...getNoteDefaultOptions as unknown as Omit<UseQueryOptions<Types.NoteDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetNoteData(queryClient: QueryClient, updater: (data: Types.NoteDto | undefined) => Types.NoteDto, id: number) {
  queryClient.setQueryData(getNoteQueryKey(id),
    updater
  );
}

export function setGetNoteDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.NoteDto | undefined) => Types.NoteDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function updateNoteUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/note/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateNoteMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'NoteClient',
      'updateNote',
      id as any,
    ]);
}

export function useUpdateNoteMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.NoteDto, unknown, Types.UpdateNoteDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.NoteDto, unknown, Types.UpdateNoteDto, TContext> {
  const key = updateNoteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (updateDto: Types.UpdateNoteDto) => Client.updateNote(id, updateDto),
    mutationKey: key,
  });
}
  
type UpdateNote__MutationParameters = UpdateNoteNoteQueryParameters & {
  updateDto: Types.UpdateNoteDto;
}

export function useUpdateNoteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.NoteDto, unknown, UpdateNote__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateNoteNoteQueryParameters}): UseMutationResult<Types.NoteDto, unknown, UpdateNote__MutationParameters, TContext> {
  const key = updateNoteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UpdateNote__MutationParameters) => Client.updateNote(data.id ?? options?.parameters?.id!, data.updateDto),
  mutationKey: key,
});
}
  
export function removeNoteUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/note/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeNoteMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'NoteClient',
      'removeNote',
      id as any,
    ]);
}

export function useRemoveNoteMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeNoteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeNote(id),
    mutationKey: key,
  });
}
  
type RemoveNote__MutationParameters = RemoveNoteNoteQueryParameters

export function useRemoveNoteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemoveNote__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveNoteNoteQueryParameters}): UseMutationResult<void, unknown, RemoveNote__MutationParameters, TContext> {
  const key = removeNoteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemoveNote__MutationParameters) => Client.removeNote(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getUrl(from?: Date | null | undefined, to?: Date | null | undefined, endsTill?: Date | null | undefined, importId?: string | null | undefined, excludeWithoutDates?: boolean | null | undefined, importIds?: string[] | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/note?";
if (from !== undefined && from !== null)
    url_ += "From=" + encodeURIComponent(from ? "" + Types.formatDate(from) : "") + "&";
if (to !== undefined && to !== null)
    url_ += "To=" + encodeURIComponent(to ? "" + Types.formatDate(to) : "") + "&";
if (endsTill !== undefined && endsTill !== null)
    url_ += "EndsTill=" + encodeURIComponent(endsTill ? "" + Types.formatDate(endsTill) : "") + "&";
if (importId !== undefined && importId !== null)
    url_ += "ImportId=" + encodeURIComponent("" + importId) + "&";
if (excludeWithoutDates !== undefined && excludeWithoutDates !== null)
    url_ += "ExcludeWithoutDates=" + encodeURIComponent("" + excludeWithoutDates) + "&";
if (importIds !== undefined && importIds !== null)
    importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfNoteDto, unknown, Types.PageableListDtoOfNoteDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfNoteDto, unknown, Types.PageableListDtoOfNoteDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetNoteQueryParameters): QueryKey;
export function getQueryKey(from?: Date | null | undefined, to?: Date | null | undefined, endsTill?: Date | null | undefined, importId?: string | null | undefined, excludeWithoutDates?: boolean | null | undefined, importIds?: string[] | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { from, to, endsTill, importId, excludeWithoutDates, importIds, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetNoteQueryParameters;

    return trimArrayEnd([
        'NoteClient',
        'get',
        from as any,
        to as any,
        endsTill as any,
        importId as any,
        excludeWithoutDates as any,
        importIds as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'NoteClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as Date | null | undefined,       context.queryKey[3] as Date | null | undefined,       context.queryKey[4] as Date | null | undefined,       context.queryKey[5] as string | null | undefined,       context.queryKey[6] as boolean | null | undefined,       context.queryKey[7] as string[] | null | undefined,       context.queryKey[8] as number | undefined,       context.queryKey[9] as number | undefined,       context.queryKey[10] as string | null | undefined,       context.queryKey[11] as Types.SortDirection | undefined,       context.queryKey[12] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.PageableListDtoOfNoteDto, TError = unknown>(dto: GetNoteQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfNoteDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param from (optional) Returns Notes that starts or ends after this date
 * @param to (optional) Returns Notes that starts before this date
 * @param endsTill (optional) Returns notes that ends before passed date (including)
 * @param importId (optional) 
 * @param excludeWithoutDates (optional) Filters out Notes with unspecified StartDate
 * @param importIds (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetQuery<TSelectData = Types.PageableListDtoOfNoteDto, TError = unknown>(from?: Date | null | undefined, to?: Date | null | undefined, endsTill?: Date | null | undefined, importId?: string | null | undefined, excludeWithoutDates?: boolean | null | undefined, importIds?: string[] | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfNoteDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.PageableListDtoOfNoteDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfNoteDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let from: any = undefined;
  let to: any = undefined;
  let endsTill: any = undefined;
  let importId: any = undefined;
  let excludeWithoutDates: any = undefined;
  let importIds: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ from, to, endsTill, importId, excludeWithoutDates, importIds, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetNoteQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [from, to, endsTill, importId, excludeWithoutDates, importIds, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfNoteDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(from, to, endsTill, importId, excludeWithoutDates, importIds, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfNoteDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param from (optional) Returns Notes that starts or ends after this date
 * @param to (optional) Returns Notes that starts before this date
 * @param endsTill (optional) Returns notes that ends before passed date (including)
 * @param importId (optional) 
 * @param excludeWithoutDates (optional) Filters out Notes with unspecified StartDate
 * @param importIds (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfNoteDto | undefined) => Types.PageableListDtoOfNoteDto, from?: Date | null | undefined, to?: Date | null | undefined, endsTill?: Date | null | undefined, importId?: string | null | undefined, excludeWithoutDates?: boolean | null | undefined, importIds?: string[] | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getQueryKey(from, to, endsTill, importId, excludeWithoutDates, importIds, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * @param from (optional) Returns Notes that starts or ends after this date
 * @param to (optional) Returns Notes that starts before this date
 * @param endsTill (optional) Returns notes that ends before passed date (including)
 * @param importId (optional) 
 * @param excludeWithoutDates (optional) Filters out Notes with unspecified StartDate
 * @param importIds (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfNoteDto | undefined) => Types.PageableListDtoOfNoteDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createNoteUrl(): string {
  let url_ = getBaseUrl() + "/api/note";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createNoteMutationKey(): MutationKey {
  return trimArrayEnd([
      'NoteClient',
      'createNote',
    ]);
}

export function useCreateNoteMutation<TContext>(options?: Omit<UseMutationOptions<Types.NoteDto, unknown, Types.CreateNoteDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.NoteDto, unknown, Types.CreateNoteDto, TContext> {
  const key = createNoteMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (createDto: Types.CreateNoteDto) => Client.createNote(createDto),
    mutationKey: key,
  });
}